export type ModifierName = 'alt' | 'ctrl' | 'meta' | 'shift' | 'cmd';

const modifiers: readonly ModifierName[] = [
  'alt',
  'ctrl',
  'meta',
  'shift',
  'cmd',
];

export default modifiers;
